let signals = {
  name: "Сигнали",
  path: "/#/signals_oper/list",
  target: true,
  meta: { icon_fa: "fas fa-phone-square-alt" },
  groups: ["TestMainGroup", "TestDummyGroup"],
}

export default signals;